import "../css/card_design.css"

function Enterotp(){

    const disableRightClick = (e) => {
    e.preventDefault();
  };
    
    return(
        <div className="basic_design" onContextMenu={disableRightClick}>
<h2 className='title'>Enter OTP</h2>


<p>We have sent you the OTP and the link to reset your password via<br/> SMS/Email.</p>
<input  className="input-style" type="text" placeholder="Enter the OTP"/>

<p>Didn't get the OTP? <span style={{color: "rgb(65, 137, 247)",textDecoration:"none"}}>Resend OTP</span>

 <button className='send-button' style={{marginLeft:"150px",borderRadius:"10px"}}>SUBMIT</button></p>

</div>











    );
}
export default Enterotp;